import { trackHeapEvent } from '@/heap/trackHeapEvent'

export enum PhotoGalleryHeapEvents {
  saveSingle = 'location-details-save-single-photo-gallery',
  saveMultiple = 'location-details-save-multiple-photo-gallery',
}

interface ActionsCommonProps {
  status: 'Success' | 'Fail'
  imagesCount: string
}

export type SaveSingleDataProps = ActionsCommonProps & {
  storeLocationId: string
}

export type SaveMultipleDataProps = ActionsCommonProps & {
  storeLocationsCount: string
}

export const photoGalleryTrackingEvents = {
  saveForSingleLocation(data: SaveSingleDataProps) {
    trackHeapEvent(PhotoGalleryHeapEvents.saveSingle, data)
  },

  saveForMultipleLocations(data: SaveMultipleDataProps) {
    trackHeapEvent(PhotoGalleryHeapEvents.saveMultiple, data)
  },
}
